import React from 'react'
import { Props, StyledTextArea } from './styled'

export const TextArea: React.FC<Props> = (props: Props) => {
  return <StyledTextArea {...props} />
}
